<template>
  <div>
    <div class="row">
      <div class="blocheader-wrapper single-title-wrapper col-4">
        <div class="row">
          <div class="title-box col-6">
            <h1>Tous mes project</h1>
          </div>
          <div class="button-box col-6">
            <b-button
              id="show-btn"
              variant="outline-primary"
              @click="handleNewProject"
              ><font-awesome-icon :icon="['fas', 'user-plus']" />Nouveau
              Projet</b-button
            >
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-3">
        <filterComponent @handleFilter="handleFilter"></filterComponent>
      </div>
      <div class="col-9">
        <tableListing
          class="aux-table-style"
          :data-table="dataProjectList.data"
          :data-fields="dataProjectList.fields"
          @deleteAction="handleDeleteAction"
          @editAction="handleEditAction"
        >
        </tableListing>
        <b-modal
          id="modal-confirmation"
          title="Confirmation"
          ref="confirmationModal"
          :no-close-on-backdrop="true"
          :no-close-on-esc="true"
          @ok="handleOk"
          :modal-class="'base-modal'"
          cancel-variant="outline-primary"
          cancel-title="Annuler"
        >
          <p>Etes-vous certain de vouloir supprimer?</p>
        </b-modal>
      </div>
    </div>
    <edit-stepped-modal
      ref="steppedModal"
      @updateEvent="getDetailProjectsList"
    ></edit-stepped-modal>
    <edit-stepped-modal
      ref="steppedModalNewProject"
      :edit-mode="true"
      @afterSubmitForm="handleAfterSubmitForm"
    ></edit-stepped-modal>
  </div>
</template>
<script>
import { canDeleteEdit } from '../../config/constanteUse'
import { mapActions, mapGetters } from 'vuex'
import tableListing from '../../components/utils/tableListing'
import filterComponent from '../../components/utils/filterComponent'
import editSteppedModal from '../../components/editSteppedModal'
export default {
  components: {
    tableListing,
    filterComponent,
    editSteppedModal
  },
  data () {
    return {
      idProject: null,
      dataProjectList: {
        data: [],
        fields: [
          {
            name: '__slot:nom',
            title: 'Nom'
          },
          {
            name: 'client',
            title: 'Client'
          },
          {
            name: 'typeErp',
            title: 'Type'
          },
          {
            name: 'ville',
            title: 'Ville'
          },
          {
            name: 'etat',
            title: 'Etat'
          },
          {
            name: 'numeroAffaire',
            title: "Numero d'affaire"
          },
          {
            name: '__slot:actions',
            title: 'Actions',
            visible: canDeleteEdit.includes(this.userRole())
          }
        ]
      }

    }
  },
  mounted () {
    this.getDetailProjectsList()
  },
  methods: {
    ...mapActions(['getProjectsByClient', 'deleteProject', 'setProjectData', 'getProjectById', 'getFilterResults']),
    ...mapGetters(['userId', 'userSocieteId', 'userRole', 'nom']),
    getDetailProjectsList () {
      this.getProjectsByClient({ socId: this.userSocieteId(), clientId: this.userId(), page: 0 }).then(resp => {
        this.formatDataProjectList(resp.items)
      })
    },
    formatDataProjectList (data) {
      this.dataProjectList.data = data.map(x => {
        let typeErp = x.typeErp.map(y => y.nom)
        return {
          id: x.id,
          nom: x.nom,
          client: x.client.nom,
          typeErp: typeErp.toString(),
          ville: x.ville,
          numeroAffaire: x.numeroAffaire,
          etat: x.etat === 1 ? 'En cours' : 'Terminé'
        }
      })
    },
    handleNewProject () {
      this.$refs['steppedModalNewProject'].openModal()
    },
    handleDeleteAction (id) {
      this.$refs.confirmationModal.show()
      this.idProject = id
    },
    handleEditAction (id) {
      this.getProjectById(id).then(resp => {
        this.setProjectData(resp)
        this.$refs['steppedModal'].openModal(id)
      })
    },
    handleOk () {
      this.deleteProject(this.idProject).then(resp => {
        this.$toaster.success('Projet supprimé')
        this.dataProjectList.data = this.dataProjectList.data.filter((value, index, arr) => {
          return value.id !== this.idProject
        })
      })
    },
    handleFilter (data) {
      // 'page=1&parPage=20&filtres[nom]=test&filtres[client]=&filtres[typeErp]=&filtres[ville]=yve'
      let urlParams = 'page=0&parPage=20'
      urlParams += data.nom ? '&filtres[nom]=' + data.nom : '&filtres[nom]='
      urlParams += data.client ? '&filtres[client]=' + data.client : '&filtres[client]='
      urlParams += data.typeErp ? '&filtres[typeErp]=' + data.typeErp : '&filtres[typeErp]='
      urlParams += data.ville ? '&filtres[ville]=' + data.ville : '&filtres[ville]='
      urlParams += data.numeroAffaire ? '&filtres[numeroAffaire]=' + data.numeroAffaire : '&filtres[numeroAffaire]='
      urlParams += data.statut ? '&filtres[etat]=' + (data.statut === 'En cours' ? 1 : 3) : '&filtres[etat]='

      this.getFilterResults({ id: this.userSocieteId(), data: urlParams }).then((resp) => {
        this.formatDataProjectList(resp)
      })
    },
    handleAfterSubmitForm (id) {
      this.$router.push('../mes-tableaux/' + id)
    }
  }
}
</script>
<style lang="scss">
#modal-confirmation {
  p {
    font-family: "Open Sans";
    font-weight: 400;
    font-size: 13px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/pageAllProjects/index.vue